module.exports = __webpack_public_path__ + "static/intertec_product_3-5b19196185a5348b0f3e1b7686036751.png";